/* eslint-disable no-nested-ternary */
/* eslint-disable react/sort-comp */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */
import {
  Box,
  Button,
  fileExtension,
  isAcceptedFileType,
  FileUploadState,
  UploadAttributesState,
  getFileIngestionErrors,
  AdvancedFileUploadDropzone,
  UploadSessionState,
  CircularProgress,
  Spinner,
  Icon,
} from '@ouster/webviz-react-components';
import type {
  FileIngestionResults,
  UploadedFileInfo,
} from '@ouster/webviz-react-components';

import { isEmpty } from 'lodash';
import { parseTar } from 'nanotar';
import { PureComponent } from 'react';
import { RiInformationLine } from 'react-icons/ri';
import styled from 'styled-components/macro';

// eslint-disable-next-line import/no-cycle
import { Modal, ModalBackground } from './Modal';
import UploadAttributes from '../components/UploadAttributes';
import UploadSpaceUsage from '../components/UploadSpaceUsage';
import { DataCategory, User, Tag, OrgSpaceUsage } from '../types';
import { BASE_ORG_API, SINGLE_FILE_LIMIT } from '../utils/constants';
import { typeformLinkFromUser } from '../utils/feedbackForm';
import { formatBytesToGB } from '../utils/misc';
import { fetchWithAuth, fetchWithAuthV2 } from '../utils/requests';
import { onSubmit } from '../utils/submitUpload';

// Constants
const ACCEPTED_DATA_EXTENSIONS = ['pcap', 'osf', 'bag'];
let ACCEPTED_CONFIG_EXTENSIONS = ['json', 'tar'];

/* 
Use wakeLock api to keep tab active during upload so the computer won't go sleep
*/
let wakeLock: WakeLockSentinel | null = null;

const StyledModalBackground = styled(ModalBackground)`
  /* Use grid instead of flex for the container so the modal can stay
  centered and overflow beyond its padding when too small */
  display: grid;
  align-items: center;
  justify-items: center;
`;

const StyledModal = styled(Modal)<{ disableModal?: boolean }>`
  /* Override min-width to allow to shrink */
  min-width: 0;
  max-width: 1280px;
  display: grid;
  grid-template-columns: 1fr auto;
  max-height: 90svh;
  overflow-y: auto;
  pointer-events: ${({ disableModal }) => (disableModal ? 'none' : 'auto')};

  @media (max-width: 1280px) {
    width: calc(100% - 40px);
  }
`;

const ModalTitle = styled.h3`
  color: ${(props) => props.theme.textDefaultColor};
  font-weight: 500;
  font-size: 28px;
  margin-top: -1rem;

  @media (max-width: 1280px) {
    font-size: 24px;
  }
`;

const UploadButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 6px;
`;

// TODO: shift back to all caps if the request body accepts it
enum SensorDataType {
  bag = 'sdk_bag_data',
  osf = 'sdk_osf_data',
  pcap = 'sdk_pcap_data',
  unknown = 'unknown',
}

type ConfigFileStatus =
  | {
      id: string;
      state: 'ready';
      ingestionResult: FileIngestionResults; // Required when state is 'ready'
      warnings?: string;
      fatalErrors?: { message: string }[]; // Adjust based on your error structure
    }
  | {
      id: string;
      state: 'uploaded' | 'waiting' | 'failed';
      ingestionResult?: FileIngestionResults; // Optional for other states
      warnings?: string;
      fatalErrors?: { message: string }[]; // Adjust based on your error structure
    };

type Props = {
  closeUploadViewFn: () => void;
  refreshToastFn: (dataCategory: DataCategory, isAutoSubmit: boolean) => void;
  user?: User;
  orgId: number;
  orgName: string;
  orgSpaceUsage: OrgSpaceUsage;
};

type State = {
  uploadSessionID?: string;
  sessionState: UploadSessionState;
  dataUploadState: FileUploadState;
  dataUploadId?: string;
  dataInfo?: UploadedFileInfo;
  dataUploadProgress: number;
  timeOfLastDataProgress: number;
  timeToDataUploadComplete: number;
  dataUploadType: SensorDataType;
  isConfigRequired: boolean;
  hideConfigForNewBag: boolean;
  dataUploadReq?: XMLHttpRequest;
  configUploadState: FileUploadState;
  configUploadId?: string[];
  configInfo?: UploadedFileInfo | FileIngestionResults;
  extractConfigInfo?: FileIngestionResults[];
  configFile?: File;
  configUploadProgress: number;
  timeOfLastConfigProgress: number;
  timeToConfigUploadComplete: number;
  configUploadReq?: XMLHttpRequest;
  uploadAttributesState: UploadAttributesState;
  dataCategory?: DataCategory;
  selectedTags: Tag[];
  dataWarningText?: string;
  dataErrorText?: string;
  configErrorText?: string;
  configWarningText?: string;
  uploadDataSize: number;
  uploadConfigSize: number;
  isSubmitted: boolean;
  dataSizeLimitExceed: boolean;
  isAutoSubmit: boolean;
  isPolling: boolean;
  isValidating: boolean;
};

/**
 * Upload modal for initiating upload sessions to data app
 * TODO: better warning when user attempts to upload both an osf and a json, we currently just ignore the json
 */
export class UploadView extends PureComponent<Props, State> {
  /**
   * Constructor for upload view
   * @param props props
   */
  constructor(props: Props) {
    super(props);
    this.state = {
      uploadSessionID: undefined,
      sessionState: UploadSessionState.notStarted,
      dataUploadState: FileUploadState.active,
      dataUploadProgress: 0,
      timeOfLastDataProgress: Date.now(),
      timeToDataUploadComplete: 0,
      // eslint-disable-next-line react/no-unused-state
      dataUploadType: SensorDataType.unknown, // TODO remove
      isConfigRequired: true,
      hideConfigForNewBag: false,
      configUploadState: FileUploadState.disabled,
      configUploadProgress: 0,
      timeOfLastConfigProgress: Date.now(),
      timeToConfigUploadComplete: 0,
      uploadAttributesState: UploadAttributesState.active,
      selectedTags: [],
      uploadDataSize: 0,
      uploadConfigSize: 0,
      isSubmitted: false,
      dataSizeLimitExceed: false,
      isAutoSubmit: false,
      isPolling: false,
      isValidating: false,
    };
  }

  // XHR Helper to upload signed URL while getting upload progress
  uploadFileWithProgress = (
    signedURL: string,
    file: File,
    onStart: () => void,
    updateCallback: (pctUploaded: number, ts: number) => void,
    completionCallback: () => void // TODO: Update on completion with API response
  ) => {
    const xhr = new XMLHttpRequest();
    xhr.upload.addEventListener('progress', (evt) => {
      const fileSize = file.size;
      const pctUploaded = Math.min((evt.loaded / fileSize) * 100, 100); // Avoid over 100%? debug
      updateCallback(pctUploaded, Date.now());
    });
    xhr.addEventListener('load', completionCallback);
    xhr.open('PUT', `${signedURL}`);
    xhr.setRequestHeader('Content-Type', 'application/octet-stream');
    xhr.send(file);
    onStart();
    return xhr;
  };

  lastCalculatedETA = 0;

  lastCalculatedTime = 0;

  lastConfigCalculatedETA = 0;

  lastConfigCalculatedTime = 0;

  // HELPER: Estimate upload time
  // TODO: make better
  estimateTimeLeft = (
    prevProgress: number,
    pctUploaded: number,
    timeDiff: number,
    isConfig = false
  ) => {
    // When progress is below 1%, return 0 so estimating text will be shown
    if (pctUploaded < 1) {
      return isConfig ? 1 : 0;
    }

    const now = Date.now();
    // Use appropriate throttling intervals based on file type
    // config files are smaller and more frequent, so we use a shorter interval 500ms
    const throttleInterval = isConfig ? 500 : 2000;
    const lastTime = isConfig
      ? this.lastConfigCalculatedTime
      : this.lastCalculatedTime;
    const lastETA = isConfig
      ? this.lastConfigCalculatedETA
      : this.lastCalculatedETA;

    // Throttle updates to reduce flickering
    if (now - lastTime < throttleInterval && lastETA > 0) {
      return lastETA;
    }

    const pctDiff = pctUploaded - prevProgress;
    const pctPerSec = pctDiff / (timeDiff / 1000);

    // Return previous estimate if progress too small to measure accurately
    if (pctPerSec < 0.01) {
      return lastETA || (isConfig ? 1 : 0);
    }

    const pctToGo = 100 - pctUploaded;
    let secondsToGo;

    if (isConfig) {
      // Config files: more aggressive estimates, minimal rounding
      secondsToGo = Math.max(1, pctToGo / (pctPerSec * 1.5));
      secondsToGo = Math.round(secondsToGo);
    } else {
      // Data files: standard estimates with stability improvements
      secondsToGo = pctToGo / pctPerSec;
      // Round to nearest 5 seconds for larger values to reduce jumpiness
      secondsToGo =
        secondsToGo > 60
          ? Math.round(secondsToGo / 5) * 5
          : Math.round(secondsToGo);
    }

    // Update the appropriate cached values
    const calculatedETA = Math.floor(secondsToGo);
    if (isConfig) {
      this.lastConfigCalculatedETA = calculatedETA;
      this.lastConfigCalculatedTime = now;
    } else {
      this.lastCalculatedETA = calculatedETA;
      this.lastCalculatedTime = now;
    }

    return isConfig ? this.lastConfigCalculatedETA : this.lastCalculatedETA;
  };

  // HELPER:check whether upload will exceed the total allowed limit
  // if allow_space = -1, it means the org doesn't have usage limitation
  isExceedUsageLimitation = (dataSize: number, configSize: number) => {
    const { orgSpaceUsage } = this.props;
    const { allowed_space, space_used } = orgSpaceUsage;
    return (
      allowed_space !== -1 && dataSize + configSize + space_used > allowed_space
    );
  };

  // HELPER:check whether upload will exceed the single file limit
  // if allow_space = -1, it means the org doesn't have usage limitation
  isExceedSingleUploadLimitation = (dataSize: number) => {
    const { orgSpaceUsage } = this.props;
    const { allowed_space } = orgSpaceUsage;
    return allowed_space !== -1 && dataSize > SINGLE_FILE_LIMIT;
  };

  shareSamePrefix = (dataFile: string, configFiles: string[]): boolean => {
    // Helper function to remove the file extension
    const removeExtension = (fileName: string): string =>
      fileName.split('.').slice(0, -1).join('.'); // Removes the extension
    // Extract the prefix before the first '__' from the data file
    const dataPrefix = removeExtension(dataFile).split('__')[0];

    // Check if any config file shares the same prefix
    return configFiles.some((configFile) =>
      removeExtension(configFile).startsWith(dataPrefix)
    );
  };

  // HELPER: when wakeLock api existed, use it to keep tab wake during upload
  // release the lock after upload complete or fail.
  acquireWakeLock = async () => {
    if ('wakeLock' in navigator) {
      try {
        wakeLock = await navigator.wakeLock.request('screen');
      } catch (err) {
        console.error('Failed to acquire wake lock:', err);
      }
    } else {
      console.warn('Wake lock API not supported in this browser.');
    }
  };

  releaseWakeLock = async () => {
    if ('wakeLock' in navigator && wakeLock != null) {
      try {
        await wakeLock.release();
        wakeLock = null;
      } catch (err) {
        console.error('Failed to release wake lock:', err);
      }
    } else {
      console.warn('Wake lock API not supported in this browser.');
    }
  };

  // State Update Functions
  // We handle osf differently from pcap and bag files, as it does not need an accompanying config file.
  onDataUpload = async (files: File[]) => {
    const { uploadConfigSize, configFile } = this.state;
    const dataFiles = files.filter((file) =>
      isAcceptedFileType(file, ACCEPTED_DATA_EXTENSIONS)
    );
    const configFiles = files.filter((file) =>
      isAcceptedFileType(file, ACCEPTED_CONFIG_EXTENSIONS)
    );

    if (dataFiles.length === 0) {
      this.onDataError(
        `Please upload data with the following extensions \
        ${ACCEPTED_DATA_EXTENSIONS}.`
      );
      return;
    }
    if (dataFiles.length > 1) {
      this.onDataError(
        `It looks like you uploaded multiple data files with \
        extensions ${ACCEPTED_DATA_EXTENSIONS}. We can only \
        process one file at this point.`
      );
      return;
    }

    const dataFile = dataFiles[0];

    if (this.isExceedSingleUploadLimitation(dataFile.size)) {
      this.onDataError(
        `The file you're attempting to upload exceeds the size limit for a single file (100GiB).`
      );
      this.setState({ dataSizeLimitExceed: true });
      return;
    }
    this.setState({ dataSizeLimitExceed: false });
    /* 
      error out when user try to upload more than they allow
    */
    if (this.isExceedUsageLimitation(dataFile.size, uploadConfigSize)) {
      this.onDataError(
        `The ${formatBytesToGB(
          dataFile.size
        )} file you're attempting to upload surpasses your organization's storage limit.`
      );
      return;
    }

    this.setState({
      dataInfo: {
        name: dataFile.name,
        lastModified: dataFile.lastModified,
        size: dataFile.size,
      },
      // Reset errors
      dataWarningText: undefined,
      dataErrorText: undefined,
      uploadDataSize: dataFile.size,
    });

    const extension = fileExtension(dataFile.name);
    let dataType = SensorDataType.unknown;
    let isConfigRequired: boolean;
    if (extension === 'bag') {
      dataType = SensorDataType.bag;
      isConfigRequired = true;
      this.setState({
        isConfigRequired: true,
        dataUploadType: SensorDataType.bag,
      });
    } else if (extension === 'osf') {
      dataType = SensorDataType.osf;
      // If the upload is an OSF, we don't require
      // an accompanying json file. Thus, we set
      // config upload state to initializing to display a
      // spinner until OSF ingestion results are available to display
      isConfigRequired = false;
      this.setState({
        isConfigRequired: false,
        configUploadState: FileUploadState.initializing,
        dataUploadType: SensorDataType.osf,
      });
    } else if (extension === 'pcap') {
      dataType = SensorDataType.pcap;
      isConfigRequired = true;
      this.setState({
        isConfigRequired: true,
        dataUploadType: SensorDataType.pcap,
      });
    } else {
      this.onDataError('Unrecognized file type.');
      return;
    }

    // If the data upload is an OSF/config is not required
    // And we maintained a previously dropped config file, remove it
    if (!isConfigRequired) {
      this.setState({
        configUploadProgress: 0,
        configFile: undefined,
        configInfo: undefined,
        configUploadId: undefined,
        configUploadReq: undefined,
        uploadConfigSize: 0,
      });
    }

    // Start UploadSession if no ID
    // Can only start here because we need the filetype to start the session.

    let { uploadSessionID } = this.state;
    const { configUploadState } = this.state;
    const { orgId } = this.props;
    if (!uploadSessionID) {
      console.log('Initiating upload session');
      this.setState({
        sessionState: UploadSessionState.initializing,
        dataUploadState: FileUploadState.initializing,
      });
      const uploadUrl = `${BASE_ORG_API}/${orgId}/uploads/`;

      try {
        const uploaderCreationResponse = await fetchWithAuth(uploadUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ type: dataType }),
        });

        if (!uploaderCreationResponse.ok) {
          throw new Error('Failed to initiate upload session.');
        }

        const respBody = await uploaderCreationResponse.json();
        const newUploadSessionID = respBody.uuid;

        // Facilitate debugging by seeing the uuid in the console
        console.log(`Upload session UUID: ${newUploadSessionID}`);

        uploadSessionID = newUploadSessionID;
        this.setState({
          uploadSessionID: newUploadSessionID,
          sessionState: UploadSessionState.incomplete,
        });
      } catch (error) {
        this.onDataError('Failed to initiate upload session.');
        this.setState({
          sessionState: UploadSessionState.error,
        });
        // Return early. The user will have to reupload a new file
        return;
      }
    }

    // Get signed URL for file upload
    const fileUploadUrl = `${BASE_ORG_API}/${orgId}/uploads/${uploadSessionID}/files/`;
    const uploadSignedURL = await fetchWithAuth(fileUploadUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ name: dataFile.name }),
    })
      .then((resp) => resp.json())
      .then((respBody) => {
        this.setState({
          dataUploadState: FileUploadState.inProgress,
          dataUploadId: respBody.uuid,
        });
        return respBody.signed_url;
      })
      .catch((err) => {
        console.warn(err);
        this.onDataError(
          'An unpredicted error occurred during the upload of your file'
        );
      });

    // Use Signed URL to upload file
    // TODO: Error handling
    const dataXMLReq: XMLHttpRequest = this.uploadFileWithProgress(
      uploadSignedURL as string,
      dataFile,
      () => {
        this.setState({
          timeOfLastDataProgress: Date.now(),
        });
      },
      (pctUploaded, ts) => {
        const { dataUploadProgress, timeOfLastDataProgress } = this.state;
        const timeDiff = ts - timeOfLastDataProgress;
        const timeToGo = this.estimateTimeLeft(
          dataUploadProgress,
          pctUploaded,
          timeDiff,
          false
        );

        this.setState({
          dataUploadProgress: pctUploaded,
          timeOfLastDataProgress: ts,
          timeToDataUploadComplete: timeToGo,
        });
      },
      this.onDataSuccess
    );

    this.setState({
      dataUploadReq: dataXMLReq,
    });

    // If config files were also dropped, start the
    // config callback asynchronously as well
    // If a config file was already present, ignore it and use the one dropped with the data.
    if (configFiles.length !== 0 && isConfigRequired) {
      // remove previous config (add warning?)
      this.onConfigUpload(configFiles);
    } else if (configFile && uploadSessionID && isConfigRequired) {
      this.uploadConfigFile(configFile, uploadSessionID);
    } else if (configUploadState === FileUploadState.disabled) {
      // For non-osf (set to initializing already), activate config upload state
      this.setState({ configUploadState: FileUploadState.active });
    }
  };

  onDataSuccess = async () => {
    const { uploadSessionID, dataUploadId } = this.state;
    const { orgId } = this.props;
    this.setState({ isPolling: true });
    const dataStatusInterval = setInterval(() => {
      const { dataUploadState } = this.state;
      if (dataUploadState === FileUploadState.inProgress) {
        const dataStatusURL = `${BASE_ORG_API}/${orgId}/uploads/${uploadSessionID}/files/${dataUploadId}`;
        fetchWithAuth(dataStatusURL, {
          method: 'GET',
        })
          .then((resp) => resp.json())
          .then((respBody) => {
            const dataState = respBody.state;
            if (dataState === 'ready') {
              // Grab results and warnings
              const ingestionResults: FileIngestionResults =
                respBody.ingestion_result;
              const [ingestionWarnings] = getFileIngestionErrors(
                respBody.errors
              );

              // Typescript has trouble matching the conditional type of
              // newState with the return type of setState
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              this.setState((prevState) => {
                // All other fields complete, so session is complete

                const areOtherFieldsComplete =
                  prevState.uploadAttributesState ===
                    UploadAttributesState.complete &&
                  (!isEmpty(ingestionResults) ||
                    prevState.configUploadState === FileUploadState.success);

                let newState: Partial<State> = {
                  dataUploadState: FileUploadState.success,
                  dataUploadReq: undefined,
                  dataWarningText: ingestionWarnings?.[0]?.message,
                  // If other fields are complete, let the user submit
                  // their whole upload
                  sessionState: areOtherFieldsComplete
                    ? UploadSessionState.complete
                    : prevState.sessionState,
                };

                /* 
                  OSF and new Bag file doesn't require json
                  we set config to complete and update the file display
                  when we receive ingestionResults
                */
                if (!isEmpty(ingestionResults)) {
                  newState = {
                    ...newState,
                    isConfigRequired: false,
                    hideConfigForNewBag: true,
                    configUploadProgress: 0,
                    configFile: undefined,
                    configUploadId: undefined,
                    uploadConfigSize: 0,
                    configUploadState: FileUploadState.success,
                    configUploadReq: undefined,
                    configInfo: ingestionResults,
                    extractConfigInfo: [ingestionResults],
                  };
                }

                return newState;
              });

              // Cancel interval
              clearInterval(dataStatusInterval);
              this.setState({ isPolling: false });
            } else if (dataState === 'uploaded' || dataState === 'waiting') {
              // Do nothing
            } else {
              console.warn('Data ingestion failed');
              const [, fatalErrors] = getFileIngestionErrors(respBody.errors);
              // Only display the first error to not overflow the component
              this.onDataError(
                fatalErrors?.[0]?.message ||
                  'Something went wrong uploading your file.'
              );
              clearInterval(dataStatusInterval);
              this.setState({ isPolling: false });
            }
          })
          .catch(() => {
            this.onDataError('Unable to find file');
          });
      } else {
        clearInterval(dataStatusInterval);
        this.setState({ isPolling: false });
      }
    }, 1000);
  };

  // On Error post upload completion, or wrong file type
  onDataError = (errorMsg: string) => {
    // If OSF, clear config state as well
    const { isConfigRequired, uploadSessionID, dataUploadId } = this.state;
    const { orgId } = this.props;

    if (!isConfigRequired) {
      this.setState({
        configUploadState: FileUploadState.disabled,
        // TODO clear additional config state
      });
    }

    this.setState({
      sessionState: UploadSessionState.error,
      dataUploadState: FileUploadState.error,
      dataUploadProgress: 0,
      dataUploadReq: undefined,
      dataErrorText: errorMsg,
      uploadDataSize: 0,
    });

    if (uploadSessionID && dataUploadId) {
      const dataDeleteURL = `${BASE_ORG_API}/${orgId}/uploads/${uploadSessionID}/files/${dataUploadId}`;
      fetchWithAuth(dataDeleteURL, {
        method: 'DELETE',
      });
    }

    return errorMsg;
  };

  onDataRemoval = () => {
    // TODO: call file deletion on API once completed?
    // Cancel request if there
    const {
      dataUploadReq,
      uploadSessionID,
      dataUploadId,
      isConfigRequired,
      configInfo,
    } = this.state;
    const { orgId } = this.props;

    if (dataUploadReq) {
      dataUploadReq.abort();
    }

    if (uploadSessionID && dataUploadId) {
      const dataDeleteURL = `${BASE_ORG_API}/${orgId}/uploads/${uploadSessionID}/files/${dataUploadId}`;
      fetchWithAuth(dataDeleteURL, {
        method: 'DELETE',
      });
    }

    // In the case of osf (config not required), we also reset the config state to disabled
    if (!isConfigRequired) {
      this.setState({
        configUploadState: FileUploadState.disabled,
        configInfo: undefined,
        isConfigRequired: true,
        hideConfigForNewBag: false,
      });
    }

    /* 
      when data is removed, we need to assign a new upload session id.
    */

    this.lastCalculatedETA = 0;
    this.lastCalculatedTime = 0;

    this.setState({
      // Sure upload status based on whether we have config file
      // if we do, we will still show the config upload progress bar
      sessionState: configInfo
        ? UploadSessionState.incomplete
        : UploadSessionState.notStarted,
      dataUploadState: FileUploadState.active,
      dataInfo: undefined,
      dataUploadProgress: 0,
      dataUploadId: undefined,
      dataUploadReq: undefined,
      dataErrorText: undefined,
      dataWarningText: undefined,
      uploadDataSize: 0,
      timeToDataUploadComplete: 0,
      uploadSessionID: undefined,
      isAutoSubmit: false,
    });

    this.onConfigRemoval();
  };

  uploadConfigFile = async (configFile: File, uploadSessionID: string) => {
    /* 
      if the configFile is .json file, we simply upload the json to bucket, save the file uuid (configUploadId) and polling to get the state of the id

      if the configFile is .tar. We need to unzip the file, find its direct .json children. Upload the .tar and .json files we find. Only save json files' uuid to configUploadId. and after upload successful, we will polling state for each json files to make sure its state is ready before we allow user to upload 
    */
    const isTarFile = configFile.name.endsWith('.tar');

    // Get signed URL for config upload
    const { orgId } = this.props;
    const configUploadUrl = `${BASE_ORG_API}/${orgId}/uploads/${uploadSessionID}/files/`;

    // To store all UUIDs for JSON files
    const jsonFileUUIDs: string[] = [];

    const getSignedURL = async (fileName: string) => {
      const response = await fetchWithAuth(configUploadUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name: fileName }),
      });
      const responseBody = await response.json();

      this.setState({
        configUploadState: FileUploadState.inProgress,
      });

      if (fileName.endsWith('.json')) {
        // if it is json file, we need to update configUploadId
        jsonFileUUIDs.push(responseBody.uuid);
      }

      return responseBody.signed_url;
    };

    if (isTarFile) {
      /*
        if it is tar file, we need to untar and get .json name, so we can call API
        to get the file uuid and poll its state
      */
      const arrayBuffer = await configFile.arrayBuffer();

      const entries = parseTar(arrayBuffer);

      // Filter for direct `.json` children
      const jsonFiles = entries.filter(
        (entry): entry is { name: string; content: Uint8Array } =>
          entry.name.endsWith('.json') && !entry.name.includes('/')
      );

      const { dataInfo, dataUploadReq, dataUploadId } = this.state;

      if (dataInfo?.name) {
        const isPrefixMatch = this.shareSamePrefix(
          dataInfo.name,
          jsonFiles.map((file) => file.name)
        );

        if (!isPrefixMatch) {
          this.onDataError(
            `The PCAP file name must match the prefix of the JSON configuration file(s) inside the TAR archive for proper processing.".`
          );

          if (dataUploadReq) {
            dataUploadReq.abort();
          }

          if (uploadSessionID && dataUploadId) {
            const dataDeleteURL = `${BASE_ORG_API}/${orgId}/uploads/${uploadSessionID}/files/${dataUploadId}`;
            fetchWithAuth(dataDeleteURL, {
              method: 'DELETE',
            });
          }

          return;
        }
      }

      await Promise.all(
        jsonFiles.map(async (jsonFile) => {
          await getSignedURL(jsonFile.name); // Pushes UUID into `jsonFileUUIDs`
        })
      );

      this.setState({
        configUploadId: jsonFileUUIDs,
      });
    } else {
      this.setState({
        configUploadId: jsonFileUUIDs,
      });
    }

    // no matter it is .tar file or single .json file, we still need to get the
    // upload signed url to upload the file to bucket.
    const uploadSignedURL = await getSignedURL(configFile.name);

    // Use Signed URL to upload file
    // eslint-disable-next-line @typescript-eslint/await-thenable
    const configXMLReq: XMLHttpRequest = this.uploadFileWithProgress(
      uploadSignedURL,
      configFile,
      () => {
        this.setState({
          timeOfLastConfigProgress: Date.now(),
        });
      },
      (pctUploaded, ts) => {
        // Generate time estimate
        const { configUploadProgress, timeOfLastConfigProgress } = this.state;
        const timeDiff = ts - timeOfLastConfigProgress;
        const timeToGo = this.estimateTimeLeft(
          configUploadProgress,
          pctUploaded,
          timeDiff,
          true
        );

        this.setState({
          configUploadProgress: pctUploaded,
          timeOfLastConfigProgress: ts,
          timeToConfigUploadComplete: timeToGo,
        });
      },
      this.onConfigSuccess
    );

    this.setState({
      configFile: undefined, // No longer need the file itself, remove
      configUploadReq: configXMLReq,
    });
  };

  onConfigUpload = async (files: File[]) => {
    const { uploadSessionID, uploadDataSize } = this.state;

    const configFiles = files.filter((file) =>
      isAcceptedFileType(file, ACCEPTED_CONFIG_EXTENSIONS)
    );

    if (configFiles.length === 0) {
      this.onConfigError(
        `Please upload config files with the following extensions \
        ${ACCEPTED_CONFIG_EXTENSIONS}.`
      );
      return;
    }
    if (configFiles.length > 1) {
      this.onConfigError(
        `It looks like you uploaded multiple config files with \
        extensions ${ACCEPTED_CONFIG_EXTENSIONS}. We can only \
        process one config file at a time.`
      );
      return;
    }

    const configFile = configFiles[0];
    if (this.isExceedSingleUploadLimitation(configFile.size)) {
      this.onDataError(
        `The file you're attempting to upload exceeds the size limit for a single file (100GiB).`
      );
      return;
    }

    /* 
      error out when user try to upload more than they allow
    */
    //  TODO - vivian combined the error message when allow multiple file upload
    if (this.isExceedUsageLimitation(uploadDataSize, configFile.size)) {
      this.onDataError(
        `When combined with the ${formatBytesToGB(
          uploadDataSize
        )} data file and ${formatBytesToGB(
          configFile.size
        )} configure file, your total upload this time will surpasses your organization's storage limit.`
      );
      this.onDataError(``);
      return;
    }

    this.setState({
      sessionState: UploadSessionState.incomplete, // Technically the upload session has not started yet
      configUploadState: FileUploadState.initializing,
      configInfo: {
        name: configFile.name,
        lastModified: configFile.lastModified,
        size: configFile.size,
      },
      // Reset warnings and errors
      configWarningText: undefined,
      configErrorText: undefined,
      uploadConfigSize: configFile.size,
    });

    if (uploadSessionID) {
      this.uploadConfigFile(configFile, uploadSessionID);
    } else {
      // If we're unable to upload the config yet - if the user hasn't yet uploaded a data file, which we need to start the upload session (need to specify data type up front) - save the file for later.
      this.setState({
        configFile,
      });
    }
  };

  onConfigSuccess = async () => {
    const { uploadSessionID, configUploadId } = this.state; // `configUploadId` is an array of UUIDs
    const { orgId } = this.props;

    const configStatusInterval = setInterval(() => {
      if (configUploadId?.length === 0) {
        clearInterval(configStatusInterval);
        return;
      }

      const { configUploadState } = this.state;

      if (configUploadState === FileUploadState.inProgress && configUploadId) {
        const fetchStatuses = configUploadId.map(
          async (id): Promise<ConfigFileStatus> => {
            const configStatusURL = `${BASE_ORG_API}/${orgId}/uploads/${uploadSessionID}/files/${id}`;
            try {
              const resp = await fetchWithAuth(configStatusURL, {
                method: 'GET',
              });
              const respBody = await resp.json();

              const [ingestionWarnings] = getFileIngestionErrors(
                respBody.errors
              );
              const [, fatalErrors] = getFileIngestionErrors(respBody.errors);

              return {
                id,
                state: respBody.state as
                  | 'ready'
                  | 'uploaded'
                  | 'waiting'
                  | 'failed',
                ingestionResult: respBody.ingestion_result,
                warnings: ingestionWarnings?.[0]?.message,
                fatalErrors,
              };
            } catch {
              return { id, state: 'failed' }; // Handle fetch errors
            }
          }
        );

        Promise.all(fetchStatuses)
          .then((statuses: ConfigFileStatus[]) => {
            const readyFiles = statuses.filter(
              (file) => file.state === 'ready'
            );
            const failedFiles = statuses.filter(
              (file) => file.state === 'failed'
            );
            const allFilesReady = readyFiles.length === configUploadId?.length;

            if (allFilesReady) {
              // All files are ready, update state to success
              const ingestionResults = readyFiles
                .map((file) => file.ingestionResult)
                .filter(
                  (result): result is FileIngestionResults =>
                    result !== undefined
                );
              const ingestionWarnings = readyFiles
                .map((file) => file.warnings)
                .filter(Boolean);

              this.setState((prevState) => {
                const areOtherFieldsComplete =
                  prevState.dataUploadState === FileUploadState.success &&
                  prevState.uploadAttributesState ===
                    UploadAttributesState.complete;

                return {
                  configUploadState: FileUploadState.success,
                  configUploadReq: undefined,
                  extractConfigInfo: ingestionResults,
                  configWarningText: ingestionWarnings?.[0],
                  sessionState: areOtherFieldsComplete
                    ? UploadSessionState.complete
                    : prevState.sessionState,
                };
              });

              clearInterval(configStatusInterval);
            } else if (failedFiles.length > 0) {
              // Handle failed files
              const firstFatalError =
                failedFiles[0]?.fatalErrors?.[0]?.message ||
                'Something went wrong uploading your file.';
              this.onConfigError(firstFatalError);
              clearInterval(configStatusInterval);
            }
          })
          .catch(() => {
            this.onConfigError('Unable to find file');
            clearInterval(configStatusInterval);
          });
      } else {
        // Upload got cancelled
        clearInterval(configStatusInterval);
      }
    }, 1000);
  };

  onConfigError = (errorMsg: string) => {
    // If no data has been uploaded yet, set the session state to error to enable the user to start fresh.
    // Otherwise, we don't want to remove the display of the already uploaded data file.
    const { dataInfo, uploadSessionID, configUploadId } = this.state;
    const { orgId } = this.props;
    if (!dataInfo) {
      // No data has been uploaded
      this.setState({
        sessionState: UploadSessionState.error,
      });
    }
    this.setState({
      configErrorText: errorMsg,
      configUploadState: FileUploadState.error,
      configUploadProgress: 0,
      configUploadReq: undefined,
      uploadConfigSize: 0,
    });

    if (uploadSessionID && configUploadId && Array.isArray(configUploadId)) {
      configUploadId.forEach((id) => {
        const configDeleteURL = `${BASE_ORG_API}/${orgId}/uploads/${uploadSessionID}/files/${id}`;
        fetchWithAuth(configDeleteURL, {
          method: 'DELETE',
        });
      });
    }
  };

  onConfigRemoval = () => {
    const { configUploadReq, uploadSessionID, configUploadId, dataInfo } =
      this.state;
    const { orgId } = this.props;
    if (configUploadReq) {
      configUploadReq.abort();
    }

    if (uploadSessionID && configUploadId && Array.isArray(configUploadId)) {
      configUploadId.forEach((id) => {
        const configDeleteURL = `${BASE_ORG_API}/${orgId}/uploads/${uploadSessionID}/files/${id}`;
        fetchWithAuth(configDeleteURL, {
          method: 'DELETE',
        });
      });
    }

    // If data file is present, set session to incomplete. if no files left, set to not started
    if (dataInfo) {
      this.setState({
        sessionState: UploadSessionState.incomplete,
      });
    } else {
      this.setState({
        sessionState: UploadSessionState.notStarted,
      });
    }

    this.lastConfigCalculatedETA = 0;
    this.lastConfigCalculatedTime = 0;

    this.setState({
      configUploadState: FileUploadState.active,
      configUploadProgress: 0,
      timeToConfigUploadComplete: 0,
      configFile: undefined,
      configInfo: undefined,
      configUploadId: undefined,
      configUploadReq: undefined,
      uploadConfigSize: 0,
    });
  };

  onUploadError = async () => {
    const { orgId } = this.props;

    const driveId = localStorage.getItem('drive_id');
    if (driveId) {
      const endpoint = `${BASE_ORG_API}/${orgId}/recordings/${driveId}`;

      await fetchWithAuthV2(endpoint, {
        method: 'DELETE',
        fallbackErrorMessage: 'Failed to delete the recording',
      });

      // clean up all previous state after upload error, the actual uploaded files will be deleted in backend when the delete api is called
      this.setState({
        sessionState: UploadSessionState.notStarted,
        dataUploadState: FileUploadState.active,
        dataInfo: undefined,
        dataUploadProgress: 0,
        dataUploadId: undefined,
        dataUploadReq: undefined,
        dataErrorText: undefined,
        dataWarningText: undefined,
        uploadDataSize: 0,
        uploadSessionID: undefined,
        isAutoSubmit: false,
        configUploadState: FileUploadState.active,
        configUploadProgress: 0,
        configFile: undefined,
        configInfo: undefined,
        configUploadId: undefined,
        configUploadReq: undefined,
        uploadConfigSize: 0,
      });
    }

    localStorage.removeItem('drive_id');
  };

  submitUpload = async () => {
    const {
      uploadSessionID,
      selectedTags,
      dataCategory,
      extractConfigInfo,
      isAutoSubmit,
      dataUploadType,
      // configUploadId,
    } = this.state;
    const { closeUploadViewFn, refreshToastFn, user, orgId } = this.props;

    /* 
      Add error catch on upload failing
    */
    this.setState({ isSubmitted: true });
    try {
      await onSubmit(
        selectedTags,
        `${BASE_ORG_API}/${orgId}/uploads`,
        orgId,
        dataUploadType === SensorDataType.osf,
        uploadSessionID,
        dataCategory,
        extractConfigInfo,
        user
        // configUploadId
      );

      this.setState({ isValidating: true });
      const validationSessionUrl = `${BASE_ORG_API}/${orgId}/uploads/${uploadSessionID}`;
      const validationPolling = setInterval(async () => {
        const response = await fetchWithAuth(validationSessionUrl, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        });
        const data = await response.json();
        if (data.state === 'moving') {
          this.setState({ isSubmitted: false });
          clearInterval(validationPolling);
          localStorage.removeItem('drive_id');
          closeUploadViewFn();
          refreshToastFn(dataCategory!, isAutoSubmit);
        } else if (
          data.state === 'failed' ||
          data.state === 'validation_failed'
        ) {
          this.setState({ isSubmitted: false, isValidating: false });
          clearInterval(validationPolling);

          await this.onUploadError();
          this.onDataError(
            'An unexpected error occurred during the validation of your recording. Please try to upload again.'
          );
        }
      }, 1000);
    } catch (error) {
      this.setState({ isSubmitted: false });
      await this.onUploadError();

      if (error instanceof Error) {
        this.onDataError(error.message);
      } else {
        this.onDataError('An unexpected error occurred during the upload');
      }
    }
  };

  onDataCategoryChange = (dataCategory?: DataCategory) => {
    if (dataCategory) {
      this.setState({
        uploadAttributesState: UploadAttributesState.complete,
        dataCategory,
      });

      // TODO: Set tags to submit later
      // Enable upload if others are also complete
      // If other fields complete, set session state to complete
      const { dataUploadState, configUploadState, isConfigRequired } =
        this.state;
      if (
        dataUploadState === FileUploadState.success &&
        (configUploadState === FileUploadState.success || !isConfigRequired)
      ) {
        this.setState({
          sessionState: UploadSessionState.complete,
        });
      }
    } else {
      // Data category deleted
      this.setState({
        sessionState: UploadSessionState.incomplete,
        uploadAttributesState: UploadAttributesState.active,
        dataCategory: undefined,
      });
    }
  };

  onTagChange = (tags: Tag[]) => {
    const { sessionState } = this.state;
    this.setState({
      selectedTags: tags,
      /* 
      It is added because when user press "clear" button to remove tags from select, the "x" button is removed as well when no tag is selected. Due to the removal of the "x" button, the clickOutside got triggered and the modal window got closed. Hence, set the state to be incomplete if sessionState is notStarted to prevent that modal close
      */
      sessionState:
        sessionState === UploadSessionState.notStarted
          ? UploadSessionState.incomplete
          : sessionState,
    });
  };

  calculateOrgUploadLimitExceed = (
    uploadConfigSize: number,
    uploadDataSize: number,
    space_used: number,
    allowed_space: number
  ) => {
    const attemptUploadSize = uploadConfigSize + uploadDataSize;
    return allowed_space === -1
      ? false
      : attemptUploadSize + space_used > allowed_space;
  };

  /**
   * On componnent mount, use wakeLock to keep tab active when upload window
   * open. Prevent the computer goes to sleep that interrupt uploading
   * https://developer.mozilla.org/en-US/docs/Web/API/Screen_Wake_Lock_API
   */
  componentDidMount() {
    this.acquireWakeLock();
  }

  /* 
    Clean wakeLock when upload window is close
  */
  /**
   * On component unmount
   */
  componentWillUnmount() {
    this.releaseWakeLock();
  }

  /**
   * Component update
   */
  componentDidUpdate() {
    const {
      sessionState,
      isSubmitted,
      uploadConfigSize,
      uploadDataSize,
      isAutoSubmit,
      configUploadState,
      dataUploadState,
    } = this.state;
    const { orgSpaceUsage } = this.props;

    if (
      configUploadState === FileUploadState.error ||
      dataUploadState === FileUploadState.error
    ) {
      this.setState({ isAutoSubmit: false });
      return;
    }

    const orgUploadLimitExceed = this.calculateOrgUploadLimitExceed(
      uploadConfigSize,
      uploadDataSize,
      orgSpaceUsage.space_used,
      orgSpaceUsage.allowed_space
    );

    if (
      sessionState === UploadSessionState.complete &&
      !orgUploadLimitExceed &&
      !isSubmitted
    ) {
      // If auto submit is set, trigger upload submission
      if (isAutoSubmit) this.submitUpload();
      // otherwise, hide the auto-submit option since there is no need for it
      this.setState({ isAutoSubmit: false });
    }
  }

  toggleAutoSubmit = () => {
    this.setState((prevState) => ({
      isAutoSubmit: !prevState.isAutoSubmit,
    }));
  };

  renderStatusMessage = () => {
    const {
      dataUploadState,
      configUploadState,
      isPolling,
      uploadAttributesState,
      dataInfo,
      extractConfigInfo,
      isConfigRequired,
      isValidating,
    } = this.state;

    // Determine if a BAG file needs a config warning
    const isBagFile = dataInfo?.name.endsWith('.bag');
    const isConfigRequiredForBag =
      isBagFile &&
      dataUploadState === FileUploadState.success &&
      !extractConfigInfo &&
      configUploadState !== FileUploadState.inProgress;

    const isConfigMissing =
      isConfigRequired &&
      dataUploadState === FileUploadState.success &&
      configUploadState === FileUploadState.active;

    // Common style props for the status message container
    const boxProps = {
      lineHeight: '1.5rem',
      px: 3,
      py: 3,
      display: 'flex',
      columnGap: 2,
      alignItems: 'center',
      borderRadius: 4,
    };

    if (isConfigRequiredForBag || isConfigMissing) {
      return (
        <Box
          {...boxProps}
          bgColor="var(--ouster-colors-red-700)"
          data-testid="config-missing-warning"
        >
          <RiInformationLine size={20} />
          <span>
            Upload cannot proceed without a JSON configuration for the provided
            data file.
          </span>
        </Box>
      );
    }
    if (isPolling) {
      return (
        <Box
          {...boxProps}
          bgColor="var(--ouster-colors-background-surface)"
          data-testid="polling-status"
        >
          <Spinner />
          <span>Processing data, it might take a while.</span>
        </Box>
      );
    }
    if (isValidating) {
      return (
        <Box
          {...boxProps}
          bgColor="var(--ouster-colors-background-surface)"
          data-testid="validating-status"
        >
          <Spinner />
          <span>Validating data, please wait.</span>
        </Box>
      );
    }
    if (
      dataUploadState === FileUploadState.inProgress ||
      configUploadState === FileUploadState.inProgress
    ) {
      return (
        <Box
          {...boxProps}
          bgColor="var(--ouster-colors-background-surface)"
          data-testid="uploading-status"
        >
          <Spinner />
          <span>Uploading in progress, please keep the window open.</span>
        </Box>
      );
    }
    if (
      dataUploadState === FileUploadState.success &&
      configUploadState === FileUploadState.success
    ) {
      const message =
        uploadAttributesState === UploadAttributesState.complete
          ? 'you can submit at any time.'
          : 'please assign category to your recording.';
      return (
        <Box
          {...boxProps}
          bgColor="var(--ouster-colors-background-surface)"
          data-testid="ready-status"
        >
          <Icon icon="checkCircle" />
          <span>Data is processed, {message}</span>
        </Box>
      );
    }
    return null;
  };

  /**
   * Render function
   * @returns upload modal component
   */
  render() {
    const { closeUploadViewFn, user, orgName, orgSpaceUsage, orgId } =
      this.props;
    const {
      sessionState,
      configUploadState,
      configUploadProgress,
      isConfigRequired,
      hideConfigForNewBag,
      timeToConfigUploadComplete,
      dataUploadState,
      dataUploadProgress,
      timeToDataUploadComplete,
      dataWarningText,
      dataErrorText,
      // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
      configErrorText,
      // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
      configWarningText,
      uploadDataSize,
      uploadConfigSize,
      uploadAttributesState,
      isSubmitted,
      dataSizeLimitExceed,
      isAutoSubmit,
      dataInfo,
      configInfo,
      dataCategory,
      selectedTags,
      isValidating,
    } = this.state;

    /* 
      For non-ouster org, multi-sensor config file .tar is NOT accepted.
    */
    ACCEPTED_CONFIG_EXTENSIONS = orgId === 1 ? ['json', 'tar'] : ['json'];

    /* 
      for org without limit (allowed_space === -1), orgUploadLimitExceed always false
      for org with limit, we need to check whether the attempt upload size + used size > allowed size
    */
    const attemptUploadSize = uploadConfigSize + uploadDataSize;
    const orgUploadLimitExceed = this.calculateOrgUploadLimitExceed(
      uploadConfigSize,
      uploadDataSize,
      orgSpaceUsage.space_used,
      orgSpaceUsage.allowed_space
    );

    const isSubmitButtonEnabled =
      sessionState === UploadSessionState.complete &&
      !orgUploadLimitExceed &&
      !isSubmitted;

    /* 
      BAG file might require configure file or not depends on its type.
      Hence, by default, we require configure for bag so user has place to upload it.
      But to make sure user can use the auto upload feature, we enable that for all .bag file by default.
    */
    const isAutoSubmitButtonEnabled =
      (dataUploadState === FileUploadState.inProgress ||
        dataUploadState === FileUploadState.success) &&
      (configUploadState === FileUploadState.inProgress ||
        configUploadState === FileUploadState.success ||
        !isConfigRequired ||
        dataInfo?.name.endsWith('.bag')) &&
      uploadAttributesState === UploadAttributesState.complete &&
      !orgUploadLimitExceed &&
      !isSubmitted;

    /* 
      After .bag file is uploaded, the code checks whether it has ingestion result returned. If not, it means the bag requires a json, then a warning message will be shown to user.
    */

    if (orgSpaceUsage.allowed_space === -999) {
      return (
        <StyledModalBackground>
          <StyledModal
            onClose={() => {
              closeUploadViewFn();
            }}
            closeOnClickOutside={
              sessionState === UploadSessionState.notStarted ||
              sessionState === UploadSessionState.error
            }
          >
            <Box padding="48px 36px" display="grid" rowGap="36px">
              <ModalTitle>Upload Data to {orgName}</ModalTitle>

              <Box fontSize={16} lineHeight={1.6}>
                Sorry, we have problem to get your storage information. Please
                refresh your page and try again.
              </Box>
              <Box display="flex" justifyContent="center" alignItems="center">
                <CircularProgress color="red" size={24} isIndeterminate />
              </Box>
            </Box>
          </StyledModal>
        </StyledModalBackground>
      );
    }

    const onCloseModalHandler = () => {
      /* 
        when user close the upload modal, we need to clean the upload session, remove the data and config
      */
      this.onDataRemoval();
      this.onConfigRemoval();
      closeUploadViewFn();
    };

    //  Disable modal interaction during ongoing submission or validation
    const disableModal = isSubmitted || isValidating;

    return (
      <StyledModalBackground>
        <StyledModal
          disableModal={disableModal}
          onClose={disableModal ? () => {} : onCloseModalHandler}
          closeOnClickOutside={
            disableModal
              ? false
              : sessionState === UploadSessionState.notStarted ||
                sessionState === UploadSessionState.error
          }
        >
          <Box padding="48px 36px" display="grid" rowGap="36px">
            <ModalTitle>Upload Data to {orgName}</ModalTitle>

            <Box
              display="grid"
              gridTemplateColumns="3fr 2fr"
              columnGap="32px"
              minHeight="360px"
            >
              <AdvancedFileUploadDropzone
                uploadState={sessionState}
                isConfigRequired={isConfigRequired}
                hideConfigForNewBag={hideConfigForNewBag}
                dataUploadState={dataUploadState}
                configUploadState={configUploadState}
                placeholderText="Placeholder"
                dataUploadProgress={dataUploadProgress}
                configUploadProgress={configUploadProgress}
                acceptedDataFormats={ACCEPTED_DATA_EXTENSIONS}
                acceptedConfigFormats={ACCEPTED_CONFIG_EXTENSIONS}
                dataUploadTimeEstimate={timeToDataUploadComplete}
                configUploadTimeEstimate={timeToConfigUploadComplete}
                titleString="Recorded Data"
                filesInfo={[
                  ...(dataInfo ? [dataInfo] : []),
                  ...(configInfo ? [configInfo] : []),
                ]}
                dataErrorText={dataErrorText}
                configErrorText={configErrorText}
                dataWarningText={dataWarningText}
                configWarningText={configWarningText}
                bugSubmissionUrl={typeformLinkFromUser(user)}
                orgUploadLimitExceed={
                  orgUploadLimitExceed || dataSizeLimitExceed
                } // add sizes
                onDataUpload={this.onDataUpload}
                onDataRemoval={this.onDataRemoval}
                onConfigUpload={this.onConfigUpload}
                onConfigRemoval={this.onConfigRemoval}
                onDataError={this.onDataError}
              />
              <UploadAttributes
                selectedDataCategory={dataCategory}
                selectedTags={selectedTags}
                onDataCategoryChange={this.onDataCategoryChange}
                onTagChange={this.onTagChange}
              />
            </Box>

            <UploadButtonContainer>
              {this.renderStatusMessage()}
              <Box marginLeft="auto">
                <Button
                  variant="solid"
                  onClick={this.submitUpload}
                  disabled={!isSubmitButtonEnabled || isValidating}
                  style={{
                    display: isSubmitButtonEnabled
                      ? 'block'
                      : isAutoSubmitButtonEnabled
                      ? 'none'
                      : 'block',
                  }}
                >
                  {isValidating ? 'Validating' : 'Submit'}
                </Button>

                <Button
                  variant="solid"
                  onClick={this.toggleAutoSubmit}
                  style={{
                    display: isSubmitButtonEnabled
                      ? 'none'
                      : isAutoSubmitButtonEnabled
                      ? 'block'
                      : 'none',
                  }}
                >
                  {isAutoSubmit ? 'Cancel Auto-submit' : 'Set Auto-submit'}
                </Button>
              </Box>
            </UploadButtonContainer>
          </Box>

          {/* 
            we will hide the usage when
            - without limitation, allowed_space = -1
            - hasn't fetched the actual data , allowed_space = 0
          */}
          {orgSpaceUsage.allowed_space > 0 && (
            <Box
              minWidth={{ base: '160px', lg: '320px' }}
              padding={{ base: '48px 16px', lg: '48px 36px' }}
              borderRadius="0 16px 16px 0"
              sx={{
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
              }}
            >
              <UploadSpaceUsage
                orgSpaceUsage={orgSpaceUsage}
                attemptUploadSize={attemptUploadSize}
              />
            </Box>
          )}
        </StyledModal>
      </StyledModalBackground>
    );
  }
}
